import {Duration} from '../Domain/Duration';
import {ScheduledEvent} from './ScheduledEvent';

export interface CalendarEvent {
    crewId: number;
    scheduledEventId: number;
    title: string;
    description: string;
    startAt: Date;
    timezone: string;
    duration: Duration;
    scheduledEvent: ScheduledEvent;
    rsvpStatuses: RsvpStatus[];
}

export interface RsvpStatus {
    userId: number;
    response: RsvpResponse;
}

export enum RsvpResponse {
    Yes = 'YES',
    No = 'NO',
    Maybe = 'MAYBE',
    Unknown = 'UNKNOWN',
}
